import { useState } from 'react'

import CoiffeurService from 'service/CoiffeurService'
import { IGetCoiffeurTimeTableList } from 'types/CoiffeurType'

export default function useSaveCoiffeurReservation(
  reservationInfo: IGetCoiffeurTimeTableList & { employeeId: number | null; subserviceId: number },
  closeAfterSave: () => void
) {
  const [loading, setLoading] = useState(false)

  const saveCoiffeurReservation = () => {
    setLoading(true)
    CoiffeurService.saveCoiffeurReservation({
      coiffeurReservationStatusId: 1,
      subserviceId: reservationInfo.subserviceId,
      employeeId: reservationInfo?.employeeId,
      coiffeurId: reservationInfo.coiffeurId,
      reservationStartHour: reservationInfo?.reservationStartHour || '',
      reservationEndHour: reservationInfo?.reservationEndHour || '',
      id: 0,
      // CancelDate: null,
    })
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { saveCoiffeurReservation, loading }
}
